const RES_CODE = {
  /**
   * 成功状态码  success
   */
  SUCCESS: 200, //成功状态码

  /**
   * 登录失效状态码  未登录
   */
  NEED_LOGIN: 800,

  /**
   * 特殊状态码  1000 = 2000 最小值
   */
  ERROR_MIN: 1000,

  /**
   * 特殊状态码  1001 = 2000  最大值
   */
  ERROR_MAX: 2000,

  /**
   * 特殊状态码  打赏人重复
   */
  ERROR_REWARD_COVER: 1001,
};

/** 业务的状态码 */
export default RES_CODE;
